<template>
  <div class="change-single-tip">
    <el-dialog title="改单费用确认" :visible.sync="visible" :before-close="closeDialog" width="720px" :close-on-click-modal="false">
      <div>
        <div style="margin-bottom:24px">校验通过！本次改单费用如下，请确认费用明细：</div>
        <div>
          <WTable :WTableOpts="WTableOpts">
            <template #price="scoped">
              <div>{{ scoped.row.price }} U币</div>
            </template>
          </WTable>
        </div>
        <div class="balance-box">
          <span>实付金额：</span>
          <span class="balance-num">{{ updateOrderFee.payAmount }}</span>
          <span>U币</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" class="submit-btn" @click="enterSendUpdateOrder">确认发送</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "ChangeSingleTip",
  props: {
    visible: Boolean,
    updateOrderFee: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      WTableOpts: {
        data: [],
        tableAttrs: { border: false },
        tableColAttrs: [
          { prop: 'masterBillNo', label: '主提单号'},
          { prop: 'houseBillNo', label: '分提单号'},
          { prop: '', label: '消费金额', slotName: 'price'}
        ]
      }
    }
  },
  created() {
    this.WTableOpts.data = this.updateOrderFee.feeItems
  },
  methods: {
    // 关闭
    closeDialog(){
      this.$emit("closeDialog")
    },
    enterSendUpdateOrder(){
      this.$emit("closeDialog")
      this.$emit("enterSendUpdateOrder", this.updateOrderFee)
    }
  }
}
</script>

<style scoped lang="less">
.change-single-tip {
  color: #333333;
  font-size: 14px;
  .dialog-footer {
    text-align: right;
  }
  .el-button {
    height: 32px;
  }
  .submit-btn {
    width: 80px;
    padding: 0;
  }
  .balance-box {
    font-weight: 500;
    text-align: right;
    margin-top: 24px;
    .balance-num {
      color: #f58d0b;
      font-size: 16px;
      margin-right: 4px;
      margin-left: 16px;
    }
  }
}
</style>